import { Stack, styled, Typography } from '@mui/material';
import { TabsCustom } from 'app/components/elements/TabsCutom';
import { useInjection } from './hook';
import React, { useCallback } from 'react';
import { headerTabUser, TabUser } from './type';
import { ClientsAccessTab } from './components/ClientsAccessTab';
import { FieldAccessTab } from './components/FieldAccessTab';

export const UserPage = () => {
  const {
    pagingInfoField,
    pagingInfoClient,
    handleChangePage,
    handleChangeTab,
    searchParams,
    clientAccess,
    fieldAccess,
    searchText,
    tab,
    optionClient,
    handleSort,
    sortOption,
    onSearch,
    handleRefreshDataClient
  } = useInjection();

  const renderTab = useCallback(() => {
    const tab = searchParams.get('tab') || TabUser.CLIENT;
    if (tab === TabUser.CLIENT) {
      return (
        <ClientsAccessTab
          handleRefreshDataClient={handleRefreshDataClient}
          onSearch={onSearch}
          sortOption={sortOption}
          handleSort={handleSort}
          pagingInfo={pagingInfoClient}
          handleChangePage={handleChangePage}
          optionClient={optionClient}
          clientAccess={clientAccess}
        />
      );
    }
    return (
      <FieldAccessTab
        pagingInfo={pagingInfoField}
        handleChangePage={handleChangePage}
        handleAddUser={() => {}}
        fieldAccess={fieldAccess}
        searchTextClient={searchText.field}
      />
    );
  }, [
    handleRefreshDataClient,
    clientAccess,
    fieldAccess,
    handleChangePage,
    handleSort,
    onSearch,
    optionClient,
    pagingInfoClient,
    pagingInfoField,
    searchParams,
    searchText.field,
    sortOption
  ]);
  return (
    <WrapperPage>
      <TitleStyled>Users</TitleStyled>
      <TabsCustom
        contentTab={renderTab()}
        tab={tab}
        headerTab={headerTabUser}
        onChangeTab={handleChangeTab}
      />
    </WrapperPage>
  );
};
const WrapperPage = styled(Stack)(() => ({
  padding: '40px 30px 30px 40px',
  width: '100%',
  height: '100vh'
}));
const TitleStyled = styled(Typography)(() => ({
  color: '#226AAA',
  fontSize: '24px',
  fontWeight: 900
}));
